var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tag-list"},_vm._l((_vm.tags),function(tag){return _c('li',{key:tag,staticClass:"tag-default tag-pill tag-outline"},[_vm._v(" "+_vm._s(tag)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }